import React from 'react';
import styled from 'styled-components';
import { Icon } from '~/components';
import { colors } from '~/styles';
import { EntityIcon, EntityImage, EntityInfo, EntityName, EntityDetail, EntityRow, Mono } from './shared';

const BuildingIcon = styled(Icon).attrs({ icon: 'building' })`
  font-size: 1.25rem;
  color: ${colors.grey10};
`;

export default function WorkspaceDisplay({ workspace, size = '1.75rem' }) {
  if (!workspace?.name) return <Mono>{workspace?.id || '-'}</Mono>;
  return (
    <EntityRow>
      <EntityIcon $size={size}>
        {workspace.imageUrl ? <EntityImage src={workspace.imageUrl} alt={workspace.name} /> : <BuildingIcon />}
      </EntityIcon>
      <EntityInfo>
        <EntityName>{workspace.name}</EntityName>
        <EntityDetail>{workspace.key}</EntityDetail>
      </EntityInfo>
    </EntityRow>
  );
}
